import { EverbayLogo } from "@/components/ui/EverbayLogo";

export function LoadingScreen() {
  return (
    <div className="fixed flex h-screen w-screen flex-col items-center justify-center">
      <EverbayLogo className="block size-16 animate-jittery" isColored />
    </div>
  );
}
